module.exports = __webpack_public_path__ + "static/2020-a2fa677c0cbf6d6f0a7cbd22704c293c.png";